<template>
  <div class="mgmt-item">
    <b-icon v-if="render && render == 'icon'" 
            :icon="getIcon(val)"
            :style="{ color: this.getIconColor(val) }"
            font-scale="1.0">
    </b-icon>

    <bar-graph  v-else-if="render && render == 'bar' && val"
                :thresholds="thresholds" 
                :val="val * 100" />

    <span v-else-if="render && render == 'numeric' && val">
      {{ getMarginText(val) || '&nbsp;' }}
    </span>
    <b-icon v-else-if="render && render.startsWith('search') && val && val.data" 
            icon="search"
            style="color: white; cursor: pointer;"
            font-scale="1.0"
            @click="showPopup = true">
    </b-icon>

    <span v-else>
      {{ getValue(val) || '&nbsp;' }}
    </span>

    <b-icon v-if="render && render == 'med'" 
            icon="bag-plus-fill"
            style="color: black;"
            font-scale="1.0">
    </b-icon>
    <popup v-if="showPopup" :title="getPopupTitle()" :popupWidth="render === 'search-contactQuota' ? 1800 : (render === 'search-phaseDuration' ? 1500 : 1024)" @close="closePopup()">
      <LeadManagementInitialLeadPopup v-if="render === 'search-initialLeadHandling'" :data="val?.data" :thresholds="thresholds"></LeadManagementInitialLeadPopup>
      <LeadManagementPhaseDurationPopup v-if="render === 'search-phaseDuration'" :data="val?.data" :thresholds="thresholds"></LeadManagementPhaseDurationPopup>
      <LeadManagementLeadClosingPopup v-if="render === 'search-leadClosing'" :data="val?.data" :thresholds="thresholds"></LeadManagementLeadClosingPopup>
      <ContactQuotaPopup v-if="render === 'search-contactQuota'" :data="val.data" :thresholds="thresholds"></ContactQuotaPopup>
    </popup>
  </div>
</template>

<script>
import BarGraph from '@/components/CX/DashboardCards/BarGraph.vue';
import Popup from '@/components/Shared/PopupFrame.vue';
import LeadManagementInitialLeadPopup from './LeadManagementInitialLeadPopup.vue';
import LeadManagementLeadClosingPopup from './LeadManagementLeadClosingPopup.vue';
import LeadManagementPhaseDurationPopup from './LeadManagementPhaseDurationPopup.vue';
import ContactQuotaPopup from './ContactQuotaPopup.vue';

export default {
  components: {
    BarGraph,
    Popup,
    LeadManagementInitialLeadPopup,
    LeadManagementLeadClosingPopup,
    LeadManagementPhaseDurationPopup,
    ContactQuotaPopup
  },

  props: {
    render: { type: String, default: undefined },
    val: { default: undefined },
    thresholds: { type: Array, required: true },

  },
  data() {
    return {
      showPopup: false,
    }
  },

  methods: {
    getPopupTitle() {
      let res = ""
      switch (this.render) {
        case 'search-initialLeadHandling':
          res = `${this.$t('Webportal.CX.Quarter')} ${this.val.quarter} - E1 ${this.$t('Webportal.CX.InitialLeadHandling')}`;
          break;
        case 'search-phaseDuration':
          res = `${this.$t('Webportal.CX.Quarter')} ${this.val.quarter} - E2 ${this.$t('Webportal.CX.PhaseDuration')}`;
          break;
        case 'search-leadClosing':
          res = `${this.$t('Webportal.CX.Quarter')} ${this.val.quarter} - E3 ${this.$t('Webportal.CX.LeadClosing')}`;
          break;
        case 'search-contactQuota':
          res = `${this.$t('Webportal.CX.Quarter')} ${this.val.quarter} - ${this.$t('Webportal.CX.ContactQuota')}`;
          break;
        default:
          break;
      }
      return res;
    },
    closePopup() {
      this.showPopup = false;
    },
    getIcon(value) {
      if(value === undefined)
        return;
      else if (value === '')
        return 'dash-circle'; // 'dash-circle-dotted';
      else if (value === false || value === 0)
        return 'x-circle-fill';
      else
        return 'check-circle-fill';
    },

    getIconColor(value) {
      if(value === undefined)
        return;
      else if (value === '')
        return '#999'; 
      else if (value === false || value === 0)
        return this.thresholds.find(s => s.Smiley == "frown-open")?.Color;
      else
        return this.thresholds.find(s => s.Smiley == "grin")?.Color;
    },

    getValue(value) {
      if (value === 0 || value === 0.0)
        return `${value}`;
      return value;
    },
    
    getMarginText(value){
      return value ? value.replace(',', '.') : null;
    }
  }
}
</script>

<style scoped>
.mc-popup {
  background: black;
  border: 1px solid white;
  position: fixed;
  width: 200px;
  height: 200px;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
